import type { DataErrorRepository, GetFiltersResult } from '../data/data-error-repository';

export class GetIrregularDeltaFiltersUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    periodFrom: string | null,
    periodTo: string | null,
    search: string
  ): Promise<GetFiltersResult & { hasError: false } | { hasError: true; errorMessage: string }> {
    try {
      const result = await this.repository.getFilters(periodFrom, periodTo, search);
      return { ...result, hasError: false };
    } catch (error: unknown) {
      return {
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to fetch filters',
      };
    }
  }
}
